import React, {useState, useEffect} from 'react'
import {useParams, Link} from 'react-router-dom'

import Loader from '../Loader/Loader';
import View from '../View/View'
import { firestore } from '../../firebase';

function RecipeCategory() {
    const {id} = useParams()

    const [isLoading, setIsloading] = useState(true);
    const [isLoadingCat, setIsloadingCat] = useState(true);
    const [posts, setPosts] = useState([]);
    const [category, setCategory] = useState()

    useEffect(() => {

        async function getBlogPost() {
            setIsloading(true)
            try {

                const recipesRef = firestore.collection("recipes")
                //recipesRef.where("categories", "array-contains", id).onSnapshot(({docs}) => {
                recipesRef.onSnapshot(({docs}) => {
                    const posts = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    console.log(posts, id)
                    const filteredPosts = posts.filter(post => {
                        console.log(post.categories)
                        console.log(post.categories.includes(id))
                        return post.categories.includes(id)
                    })
                    if (filteredPosts) {
                        setPosts(filteredPosts)
                    } else {
                        setPosts(posts)
                    }
                    
                    console.log(posts, "POSTS")
                })
                
            } catch (error) {
                console.log(error)
            }
            setIsloading(false)
        }
        getBlogPost()
    }, [id])


    useEffect(() => {

        async function getCategoryInfo() {
            setIsloadingCat(true)
            try {

                const catRef = firestore.collection("recipeCategories").doc(id);
                catRef.onSnapshot(doc => {
                    const category = {id: doc.id, ...doc.data()}
                    setCategory(category)
                })
                
            } catch (error) {
                console.log(error)
            }
            setIsloadingCat(false)
        }
        getCategoryInfo()
    }, [id])

    if (isLoading || isLoadingCat) return <Loader />

    return (
        <>
            {category ? <View text={`Kategori: ${category.category}`} image={category.featured_image} /> : <View text={`Kategori: 1`} image={""} />}
            <div className="container mt-3">
                {posts && posts.map((post, index) => {
                    
                    const date = post.date.toDate();
                    console.log(date)
                    const dateFormatted = `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`;
                    return (
                        
                        
                        <div key={index}>
                            <div className="row" key={post.id}>
                                <div className="col-xl-5 mb-2">
                                    <Link to={`/innlegg/single/${post.id}`}>
                                    <img 
                                    className="img-fluid image-thumbnail" 
                                    src={post.imageUrl ? post.imageUrl : "https://images.pexels.com/photos/94847/pexels-photo-94847.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"} />
                                    </Link>
                                </div>
            
                                <div className="col-xl-7 mb-2">
                                    <h2 className="font-weight-bold" >{post.title}</h2>
                                    <p className="text-secondary"><small>Av {post.author_name} den {dateFormatted}</small></p>
                                    <hr />
                                    <div dangerouslySetInnerHTML={{ __html: post.description}}></div>
                                     
                                    <Link className="btn btn-outline-dark" to={`/innlegg/single/${post.id}`}>Les mer</Link>
                                    
                                    
                                </div>
            
                            </div>
                            <hr />
                        </div>
                        
                        
                    )
                })}
            </div>
        </>
    )
}
export default RecipeCategory